export function childIdsForContextualForm(input: {
  mode: "create" | "edit";
  selectedChildId: string | null;
  explicitChildIds: readonly string[];
}): string[] {
  const source =
    input.mode === "create"
      ? input.selectedChildId === null
        ? []
        : [input.selectedChildId]
      : input.explicitChildIds;
  return [...new Set(source.filter((childId) => childId.length > 0))];
}
